import { drawImage } from './images.js'
import { addDamageText, getGameplayEdges, player, randomJitter, addParticle, rectanglesIntersect } from './game.js'
import Enemy from './enemy.js'
import { playSfx } from './sfx.js'

class Toad extends Enemy {
    constructor(x, y) {
        super(x, y)

        this.w = 20
        this.h = 24
        this.damage = 0.3
        this.speed = 0.13    

        this.poisonAmount = 8

        this.stats.damage.projectile = 0.0001 / this.poisonAmount
        this.stats.cooldown.duration.projectile = 6000

        this.maxHp = 10
        this.hp = this.maxHp
        this.xp = 3

        this.character = 'Toad'
        this.state = 'Idle'
        this.particleImage = 'Blood-Particle'
    }

    AnimationFrame(frame) {
        if (frame !== undefined) {
            this.animationFrame = frame
        }
        return parseInt(this.animationFrame)
    }

    ShouldAnimationPlay() {
        return true
    }

    AnimationAdvance(delta) {
        if (!this.ShouldAnimationPlay()) {
            return parseInt(this.animationFrame)
        }
        this.animationFrame += delta * this.animationSpeed
        if (this.animationFrame > this.animationFramesCount) {
            this.animationFrame = 0
            if (['Attack', 'Hurt'].includes(this.state)) {
                this.SetAnimation('Idle')
            }
        }
        return parseInt(this.animationFrame)
    }

    SetAnimation(state) {
        this.state = state
        this.animationFrame = 0
    }

    Draw(offsetx, offsety) {
        drawImage(this.character + '-' + this.state, parseInt(this.x + offsetx - this.w / 2), parseInt(this.y + offsety - this.h / 2), { x: this.AnimationFrame() * this.w, y: 0, w: this.w, h: this.h }, this.flipped)
    }

    Damage(amt) {
        if (this.state === 'Hurt' || this.dead) {
            return
        }
        
        this.hp -= amt
        this.SetAnimation('Hurt')
        if (this.hp <= 0) {
            this.hp = 0
            if (!this.dead) {
                this.dead = true
            }
        }
    }
    
    SpawnAcidParticles(deltaTime) {
        let projectileDamage = this.stats.damage.projectile
        function spawnSmoke(p, delta) {
            let smokex = p.x
            playSfx('acid')
            addParticle('Smoke-Particle', p.x, p.y, 0, -0.01, 'lighten', undefined, (smoke) => {
                if (smoke.elapsed > 800) {
                    smoke.Destroy()
                }
                smoke.x = smokex + Math.sin(smoke.y) * 0.15 * delta
                smoke.opacity = 1 - smoke.elapsed / 800            
            }).friction = 0.001
            p.Destroy()
        }
        
        function spawnUpdate(p, delta) {
            if (p.elapsed > 500) {
                spawnSmoke(p, delta)
            }
            let rect = { x: parseInt(player.x) - 4, y: parseInt(player.y) + 2, w: player.w - 4, h: player.h - 6 }
            if (player.stats.active.area === 0 && rectanglesIntersect(p.x, p.y, p.x + p.w, p.y + p.h, rect.x, rect.y, rect.x + rect.w, rect.y + rect.h)) {
                let dmg = Math.ceil(projectileDamage * deltaTime)
                player.Damage(dmg)
                spawnSmoke(p, delta)
                playSfx('playerhurt')
                addDamageText(dmg, player.x, player.y, '#f10000ff')
            } else if (player.stats.active.area > 0 && player.DistanceTo(p.x, p.y) <= player.stats.damage.range.area) {
                spawnSmoke(p, delta)
            }
            p.opacity = 1 - p.elapsed / 500
            // Simulate Gravity.
            p.movement.y += 0.00005 * delta
        }
    
        for (let n = 0; n < this.poisonAmount; n++) {        
            setTimeout(() => {
                let sx = this.x + randomJitter(-2, 2)
                let sy = this.y + randomJitter(-2, 2)
                let acidSpeed = 0.09
    
                let dx = player.x - this.x
                let dy = player.y - this.y
                let angle = Math.atan2(dy, dx)
                let mx = Math.cos(angle) * acidSpeed
                let my = Math.sin(angle) * acidSpeed

                let p1 = addParticle('Acid-Particle', sx, sy, mx, my, undefined, undefined, spawnUpdate)
                p1.friction = 0.005
                p1.w = 4
                p1.h = 4
                let p2 = addParticle('Acid-Particle', sx, sy, mx, my, undefined, undefined, spawnUpdate)
                p2.friction = 0.005
                p2.w = 4
                p2.h = 4
                let p3 = addParticle('Acid-Particle', sx, sy, mx, my, undefined, undefined, spawnUpdate)
                p3.friction = 0.005
                p3.w = 4
                p3.h = 4
            }, 15 * n)
        }
    }

    UpdateStats(delta) {
        this.stats.cooldown.melee -= delta
        if (this.stats.cooldown.melee <= 0) {
            this.stats.cooldown.melee = this.stats.cooldown.duration.melee
        }

        this.stats.cooldown.projectile -= delta
        if (this.stats.cooldown.projectile <= 0) {
            this.stats.cooldown.projectile = this.stats.cooldown.duration.projectile
            this.SpawnAcidParticles(delta)
        }
    }

    Update(delta) {
        this.AnimationAdvance(delta)

        if (this.dead) {
            return
        }

        // let dx = this.movement.x * delta * this.speed
        // let dy = this.movement.y * delta * this.speed

        let dist = Math.sqrt( Math.pow((player.x - this.x), 2) + Math.pow((player.y - this.y), 2) )
        if (dist > 3) {
            let dx = player.x - this.x
            let dy = player.y - this.y
            let angle = Math.atan2(dy, dx)
            let velX = Math.cos(angle) * this.speed
            let velY = Math.sin(angle) * this.speed
            this.x += velX
            this.y += velY
        }

        // Apply force vector to position.
        let fx = this.force.x * delta * this.stats.knockback.melee.speed
        let fy = this.force.y * delta * this.stats.knockback.melee.speed

        this.x += fx
        this.y += fy

        // Flip sides if we went off-screen.
        let edges = getGameplayEdges()
        if (this.y < edges.top) {
            this.y = edges.bottom
        }
        if (this.y > edges.bottom) {
            this.y = edges.top
        }
        if (this.x < edges.left) {
            this.x = edges.right
        }
        if (this.x > edges.right) {
            this.x = edges.left
        }

        this.ApplyFriction()
        
        this.UpdateStats(delta)

        // TODO: If melee/projectile/area cooldown is > 0, decrement by delta time.
        
        // let index = CoordinatesToTileIndex(parseInt(this.x / tileset.tilewidth), parseInt(this.y / tileset.tileheight))
        // let tileIndex = currentLevel.layers[0].data[index] - 1
        // let baseTile = tileset.tiles.filter(f => f.id === tileIndex)
        // if (baseTile.length > 0 && baseTile[0].class === 'Water') {
        //     this.standingInWater = true
        // } else {
        //     this.standingInWater = false
        // }

        // TODO: If melee/projectile/area active is > 0, apply damage to enemies in range and decrement by delta time.
        // TODO: If melee/projectile/area active == 0, set cooldown to duration.
    }
}

export default Toad